export default __webpack_public_path__ + "static/media/Bank_Accounts.4b03d8ae.pdf";